import { useIntl } from 'react-intl';
import { Button, Form } from 'antd';

import { PageProps } from '@/types/PageProps';

import { DefaultRouteTabs, SaveButton } from '@/components/_common';

import PurchaseItemsPurchase from '@/components/Movements/Purchases/PurchaseDetails/PurchaseItemsPurchase';
import { useEffect } from 'react';
import { useReleasePurchaseFormContext } from '../../ReleasesPurchaseProvider';
import { FormPurchaseItemSituation } from '../PurchaseTaxesPage';
import Authorities from '@/types/Authority';
import PurchasesButtonsRepeated from '@/components/Movements/Purchases/PurchasesButtonsRepeated';
import purchaseValidationTabs from '@/utils/functions/purchase/purchaseValidationTabs';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import PurchaseHeader from '@/components/Movements/Purchases/PurchaseHeader';

function PurchaseItemsPurchasePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<FormPurchaseItemSituation>();
  const {
    handleSubmit,
    isLoading,
    purchaseId,
    situation,
    disabled,
    purchase,
    purchaseReadOnly,
  } = useReleasePurchaseFormContext();

  useEffect(() => {
    if (situation) {
      form.setFieldsValue({ situation });
    }
  }, []);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={purchaseValidationTabs(route, purchase)}
      baseKey={purchaseId}
      basePath={`/app/movements/purchases/purchasesReleases/${purchaseId}`}
      extra={
        <SpaceForButton>
          <Button
            block
            onClick={() =>
              window.open(
                `/privateReports/purchaseItemTags?purchaseId=${purchaseId}`,
                '_blank',
              )
            }
          >
            Gerar Etiquetas
          </Button>

          <SaveButton
            block
            type="primary"
            onClick={handleSubmit}
            disabled={
              disabled ||
              purchaseReadOnly ||
              !hasPermissions([Authorities.MOVIMENTATION_PURCHASE_EDIT])
            }
            loading={isLoading}
          >
            {intl.formatMessage({ id: 'commons.entity.save' })}
          </SaveButton>
        </SpaceForButton>
      }
    >
      <PurchaseHeader />

      <PurchaseItemsPurchase
        purchaseId={Number(purchaseId)}
        purchase={purchase}
        form={form}
      />

      <PurchasesButtonsRepeated purchase={purchase} />
    </DefaultRouteTabs>
  );
}

export default PurchaseItemsPurchasePage;
